import React from 'react'
import { DumbField } from '../Field'
import {
  TextInput,
  RadioInput,
  Select,
  FullName,
  Checkbox,
  FullNameDisplay,
  DateInput,
} from './Form'
import { noop } from 'utilities'
import { getStateOptions } from '../selectOptions'
import SearchIcon from '@tecuity/sos-icons/react/search-heavy'
import RevertIcon from '@tecuity/sos-icons/react/revert'
import { Modal } from 'components/Modal/Modal'
import { HelpTooltip } from './HelpTooltip'
import Portal from 'components/Portal/Portal'
import EmptySearchPlaceholder from '../../Search/EmptySearchPlaceholder'
import {
  SEARCH_UCC_INFO_REQ,
  SEARCH_UCC_INFO_REQ_COUNT,
  SEARCH_UCC_INFO_REQ_GET_TEMPLATE,
} from 'requests'
import format from 'date-fns/format'
import { setErrorToast } from '../../../actions'
import { connect } from 'react-redux'
import { Spinner } from '../../Loaders/Loaders'
import * as WizardClasses from '../WizardClasses'
import { resolveFieldConditions } from '@tecuity/wizard-utilities'
import SearchError from '../../Search/SearchError'

const UCC_SEARCH_ALLOW_SEARCH_TYPE = process.env.UCC_SEARCH_ALLOW_SEARCH_TYPE
const UCC_SEARCH_REQUEST_TYPE_LABEL_1 = process.env.UCC_SEARCH_REQUEST_TYPE_LABEL_1
const UCC_SEARCH_REQUEST_TYPE_LABEL_2 = process.env.UCC_SEARCH_REQUEST_TYPE_LABEL_2
const UCC_SEARCH_REQUEST_TYPE_LABEL_3 = process.env.UCC_SEARCH_REQUEST_TYPE_LABEL_3
const UCC_SEARCH_NAME_ORG_LABEL = process.env.UCC_SEARCH_NAME_ORG_LABEL
const UCC_SEARCH_ONLY_REQUIRE_LAST_NAME = process.env.UCC_SEARCH_ONLY_REQUIRE_LAST_NAME
const UCC_SEARCH_ALLOW_START_DATE = process.env.UCC_SEARCH_ALLOW_START_DATE

const pageSize = 20

export const UCC11FilingList = Object.freeze({
  None: 0,
  IncludeSelected: 1,
  ExcludeSelected: 2,
})

export class UCCSearch extends React.Component {
  state = {
    modalOpen: false,
    rawRow: [],
    searching: false,
    template: [],
    searchError: '',
    searchCount: null,
  }
  componentDidMount = () => {
    this.setByKey("ADDITIONAL_PARAMS", this.getFieldParameters());
    SEARCH_UCC_INFO_REQ_GET_TEMPLATE((response) => {
      this.setState({ template: response })
    })
  }

  setByKey = (key, value) => {
    if (key === 'SEARCH_REQUEST_TYPE' && value !== 'COPIES_ONLY') {
      this.props.onChange({
        ...this.props.value,
        search: {
          ...this.props.value.search,
          [key]: value,
          SEARCH_TYPE:
            this.props.value.search.SEARCH_TYPE === 'UCC_NUM'
              ? 'DEBTOR'
              : this.props.value.search.SEARCH_TYPE,
        },
      })
    } else if (key === 'SEARCH_REQUEST_TYPE' && value === 'COPIES_ONLY') {
      this.props.onChange({
        ...this.props.value,
        search: {
          ...this.props.value.search,
          [key]: value,
          SEARCH_TYPE: 'UCC_NUM',
        },
      })
    } else {
      this.props.onChange({
        ...this.props.value,
        search: {
          ...this.props.value.search,
          [key]: value,
        },
      })
    }
  }

  setName = (name) => {
    this.props.onChange({
      ...this.props.value,
      search: {
        ...this.props.value.search,
        ...Object.entries(name).reduce(
          (obj, ent) => ({
            ...obj,
            [`SEARCH_${ent[0]}`]: ent[1],
          }),
          {}
        ),
      },
    })
  }

  buildSearch = () => {
    const { value, uccMode, defaultSearchCriteriaType, showSecuredPartySearchType } = this.props
    const isOrg = value.search.IS_ORG === 'true' || value.search.IS_ORG === true
    return {
      SEC_PARTY_SEARCH_YN: showSecuredPartySearchType,
      SEARCH_IS_ORG: isOrg,
      SEARCH_LAST_NAME: isOrg ? '' : value.search.SEARCH_LAST_NAME,
      SEARCH_FIRST_NAME: isOrg ? '' : value.search.SEARCH_FIRST_NAME,
      SEARCH_MIDDLE_NAME: isOrg ? '' : value.search.SEARCH_MIDDLE_NAME,
      SEARCH_SUFFIX: isOrg ? '' : value.search.SEARCH_SUFFIX,
      SEARCH_ORG_NAME: isOrg ? value.search.SEARCH_ORG_NAME : '',
      SEARCH_CITY: value.search.SEARCH_CITY,
      SEARCH_STATE: value.search.SEARCH_STATE,
      SEARCH_LAPSED: value.search.SEARCH_LAPSED,
      SEARCH_TYPE: value.search.SEARCH_TYPE,
      SEARCH_CRITERIA_TYPE: value.search.SEARCH_CRITERIA_TYPE || defaultSearchCriteriaType || '2',
      SEARCH_REQUEST_TYPE: value.search.SEARCH_REQUEST_TYPE,
      SEARCH_UCC: value.search.SEARCH_UCC,
      SEARCH_GOV: value.search.SEARCH_GOV,
      SEARCH_EFS: value.search.SEARCH_EFS,
      SEARCH_RA_LIEN: value.search.SEARCH_RA_LIEN,
      SEARCH_AG_LIEN: value.search.SEARCH_AG_LIEN,
      SEARCH_MODE: uccMode,
      SEARCH_UCC_NUM: value.search.SEARCH_UCC_NUM,
      BEGIN_DATE: value.search.BEGIN_DATE,
      PageNumber: value.search.PAGE_NUMBER,
      PageSize: pageSize,
      ADDITIONAL_PARAMS: this.getFieldParameters(),
    }
  }

  search = () => {
    const { skipResultSelection } = this.props
    this.setState({ searching: true })

    SEARCH_UCC_INFO_REQ_COUNT(
      this.buildSearch(),
      (count) => {
        this.setState(
          {
            modalOpen: skipResultSelection || count === 0 ? false : true,
            searching: false,
            searchError: '',
            searchCount: count,
          },
          () => {
            if (skipResultSelection || count === 0) {
              this.onConfirm({
                searchCount: count,
                indexes: [],
                selectedRows: [],
                selectionMode: UCC11FilingList.None,
                resultCount: count,
              })
            }
          }
        )
      },
      (err) => {
        console.error(err)
        this.setState({
          searching: false,
          rows: [],
          searchError: err.Message || 'An error occured.',
        })
      }
    )
  }

  onConfirm = (cache) => {
    this.setState({ cache: { ...cache, template: this.state.template } }, () => {
      if (cache.searchCount === 0) {
        this.props.onChange({
          ...this.props.value,
          cache: { ...this.state.cache },
          searchCount: 0,
          resultCount: 0,
        })
        return
      }

      this.setState({ searching: true })
      SEARCH_UCC_INFO_REQ(
        {
          ...this.buildSearch(),
          SelectedRows: cache.selectedRows,
          SelectionMode: cache.selectionMode,
        },
        (records) => {
          // for tecuity reports
          let rows = records.map((x) =>
            Object.values([
              x.Title,
              x.Debtors,
              x.FileNumber,
              x.RecordType,
              x.SecuredParties,
              x.FilingDate,
              x.LapseDate,
              x.PageCount,
            ])
          )

          this.setState(
            {
              cache: { ...this.state.cache, rows: rows, topRows: records, ids: [] },
              searching: false,
            },
            () => {
              this.props.onChange({
                ...this.props.value,
                cache: { ...this.state.cache },
                searchCount: cache.searchCount,
              })
            }
          )
        },
        (err) => {
          console.error(err)
          this.props.setErrorToast(err.Message || 'An error occured during search.')
          this.setState({
            searching: false,
            rows: [],
            searchError: err.Message || 'An error occured.',
          })
        }
      )

      if (!this.props.skipResultSelection) {
        SEARCH_UCC_INFO_REQ_COUNT(
          {
            ...this.buildSearch(),
            SelectedRows: cache.selectedRows,
            SelectionMode: cache.selectionMode,
          },
          (count) => {
            // This is the Total Selected Count as it took the SelectedRows and SelectionMode into account.
            this.setState(
              {
                cache: { ...this.state.cache, searchCount: count, resultCount: count },
                searchCount: count,
              },
              () => {
                this.props.onChange({
                  ...this.props.value,
                  cache: { ...this.state.cache },
                  searchCount: count,
                })
              }
            )
          }
        )
      }
    })
  }

  deSelect = () => {
    this.setState({ modalOpen: false })
    this.props.onChange({ ...this.props.value, cache: null })
  }

  getCanSearch = () => {
    const { value, disabled, uccMode } = this.props
    const atLeastOneBoxChecked =
      !value.search.SEARCH_UCC &&
      !value.search.SEARCH_GOV &&
      !value.search.SEARCH_EFS &&
      !value.search.SEARCH_RA_LIEN &&
      !value.search.SEARCH_AG_LIEN
    if (this.state.searching || disabled) {
      return false
    }
    if (uccMode.toString() === '4') {
      if (atLeastOneBoxChecked) {
        return false
      }
    }

    if (UCC_SEARCH_ALLOW_SEARCH_TYPE) {
      if (value.search.SEARCH_TYPE === 'DEBTOR' || value.search.SEARCH_TYPE === 'SECURED_PARTY') {
        if (value.search.IS_ORG === true || value.search.IS_ORG === 'true') {
          if (!value.search.SEARCH_ORG_NAME) {
            return false
          }
        } else if (
          (UCC_SEARCH_ONLY_REQUIRE_LAST_NAME ? false : !value.search.SEARCH_FIRST_NAME) ||
          !value.search.SEARCH_LAST_NAME
        ) {
          return false
        } else if (value.search.SEARCH_REQUEST_TYPE === 'COPIES_ONLY') {
          if (!value.search.SEARCH_UCC_NUM) {
            return false
          }
        }
      } else if (value.search.SEARCH_TYPE === 'UCC_NUM') {
        if (!value.search.SEARCH_UCC_NUM) {
          return false
        }
      }
    } else if (value.search.IS_ORG === true || value.search.IS_ORG === 'true') {
      if (!value.search.SEARCH_ORG_NAME) {
        return false
      }
    } else if (!value.search.SEARCH_FIRST_NAME || !value.search.SEARCH_LAST_NAME) {
      return false
    }

    return true
  }
  getFieldParameters = () =>
    (this.props.parameterFields || [])
      .map((fieldId) => this.props.fields[fieldId])
      .filter((x) => x)
      .filter((field) =>
        resolveFieldConditions(field.conditions, this.props.fields, field.conditionsOperator)
      )
      .map(
        (field) =>
          new WizardClasses[field.fieldClass](field).getKeyValuePairs(field, this.props.fields)[0]
      )
      .reduce(
        (obj, kv) => ({
          ...obj,
          [kv.name]: kv.value,
        }),
        {}
      )
  render() {
    const {
      value,
      disabled,
      uccMode,
      fieldId,
      showSearchCriteriaType,
      defaultSearchCriteriaType,
      searchHeader,
      showSecuredPartySearchType,
    } = this.props
    const fieldsDisabled = disabled || value.cache ? true : false
    return (
      <React.Fragment>
        <div className="sub-section organization-search ucc-box">
          <h3>
            <SearchIcon /> {searchHeader || `Search for UCC Documents`}
          </h3>
          {value.cache && (
            <div className="flex-row button-row">
              <button
                disabled={disabled}
                type="button"
                className="btn btn-raised btn-primary search-button"
                onClick={this.deSelect}
                ref={(focusTarget) => {
                  this.focusTarget = focusTarget
                }}
              >
                <RevertIcon /> &nbsp; Clear Results & Re-Search
              </button>
            </div>
          )}
          {showSearchCriteriaType ? (
            <DumbField label="Search Criteria Type" ownsLabel>
              <RadioInput
                disabled={fieldsDisabled}
                label="Search Criteria Type"
                ownsLabel
                value={value.search.SEARCH_CRITERIA_TYPE || defaultSearchCriteriaType}
                onChange={(v) => this.setByKey('SEARCH_CRITERIA_TYPE', v)}
                options={[
                  {
                    value: '1',
                    label: `RA9 Search`,
                    tooltip:
                      'The IACA search criteria standard. Does not return all filings linked to a UCC record.',
                  },
                  {
                    value: '2',
                    label: `Wildcard Search`,
                    tooltip: 'The search criteria that returns all filings linked to a UCC record.',
                  },
                ]}
              />
            </DumbField>
          ) : null}
          <DumbField
            label={UCC_SEARCH_ALLOW_SEARCH_TYPE ? 'Request Type' : 'Search Type'}
            ownsLabel
          >
            {
              <RadioInput
                value={value.search.SEARCH_REQUEST_TYPE}
                onChange={(v) => this.setByKey('SEARCH_REQUEST_TYPE', v)}
                onBlur={noop}
                disabled={fieldsDisabled}
                label={UCC_SEARCH_ALLOW_SEARCH_TYPE ? 'Request Type' : 'Search Type'}
                ownsLabel
                options={[
                  {
                    value: 'LIST_ONLY',
                    label: UCC_SEARCH_REQUEST_TYPE_LABEL_1 || 'Search request only',
                  },
                  {
                    value: 'LIST_AND_COPIES',
                    label: UCC_SEARCH_REQUEST_TYPE_LABEL_2 || 'Both search and copy request',
                  },
                  ...(UCC_SEARCH_REQUEST_TYPE_LABEL_3
                    ? [
                      {
                        value: 'COPIES_ONLY',
                        label: UCC_SEARCH_REQUEST_TYPE_LABEL_3 || 'Copy (single record number)',
                      },
                    ]
                    : []),
                ]}
              />
            }
          </DumbField>
          {UCC_SEARCH_ALLOW_SEARCH_TYPE && value.search.SEARCH_REQUEST_TYPE !== 'COPIES_ONLY' ? (
            <DumbField label="Search Type" ownsLabel>
              <RadioInput
                label="Search Type"
                ownsLabel
                leftAlign
                value={value.search.SEARCH_TYPE}
                onChange={(v) => this.setByKey('SEARCH_TYPE', v)}
                onBlur={noop}
                disabled={fieldsDisabled}
                options={
                  [
                    { value: 'DEBTOR', label: 'Debtor Search' },
                    ...(showSecuredPartySearchType ? [{ value: 'SECURED_PARTY', label: 'Secured Party Search' }]
                      : []),
                    ...(value.search.SEARCH_REQUEST_TYPE === 'COPIES_ONLY' ||
                      !UCC_SEARCH_REQUEST_TYPE_LABEL_3
                      ? [{ value: 'UCC_NUM', label: 'File Number Search' }]
                      : []),
                  ]}
              />
            </DumbField>
          ) : null}
          {(
            UCC_SEARCH_ALLOW_SEARCH_TYPE
              ? (value.search.SEARCH_TYPE === 'DEBTOR' ||
                value.search.SEARCH_TYPE === 'SECURED_PARTY') &&
              value.search.SEARCH_REQUEST_TYPE !== 'COPIES_ONLY'
              : true
          ) ? (
            <React.Fragment>
              <DumbField
                label={UCC_SEARCH_NAME_ORG_LABEL || 'Search for an Individual or Organization'}
                ownsLabel
              >
                <RadioInput
                  label={UCC_SEARCH_NAME_ORG_LABEL || 'Search for an Individual or Organization'}
                  ownsLabel
                  leftAlign
                  value={value.search.IS_ORG}
                  onChange={(v) => this.setByKey('IS_ORG', v)}
                  onBlur={noop}
                  disabled={fieldsDisabled}
                  options={[
                    { value: false, label: 'Individual' },
                    { value: true, label: 'Organization' },
                  ]}
                />
              </DumbField>
              {value.search.IS_ORG === true || value.search.IS_ORG === 'true' ? (
                <div className="flex-row">
                  <div className="no-field-padding col-sm-8 col-md-6 col-lg-4">
                    <DumbField label="Organization name" className="org-name" required>
                      <TextInput
                        value={value.search.SEARCH_ORG_NAME}
                        onChange={(v) => this.setByKey('SEARCH_ORG_NAME', v)}
                        onBlur={noop}
                        disabled={fieldsDisabled}
                        width="100%"
                      />
                    </DumbField>
                  </div>
                </div>
              ) : (
                <div className="no-field-padding">
                  <FullName
                    value={{
                      FIRST_NAME: value.search.SEARCH_FIRST_NAME,
                      LAST_NAME: value.search.SEARCH_LAST_NAME,
                      MIDDLE_NAME: value.search.SEARCH_MIDDLE_NAME,
                      SUFFIX: value.search.SEARCH_SUFFIX,
                    }}
                    onlyRequireLastName={UCC_SEARCH_ONLY_REQUIRE_LAST_NAME}
                    required
                    suffix
                    onChange={this.setName}
                    onBlur={noop}
                    disabled={fieldsDisabled}
                  />
                </div>
              )}
              <div className="no-field-padding flex-row">
                <div className="col-sm-6 col-md-8 col-lg-6">
                  <DumbField label="City">
                    <TextInput
                      value={value.search.SEARCH_CITY}
                      onChange={(v) => this.setByKey('SEARCH_CITY', v)}
                      onBlur={noop}
                      disabled={fieldsDisabled}
                      width={'100%'}
                    />
                  </DumbField>
                </div>
                <DumbField label="State">
                  <Select
                    value={value.search.SEARCH_STATE}
                    onChange={(v) => this.setByKey('SEARCH_STATE', v)}
                    options={[{ value: '', label: '' }, ...getStateOptions()]}
                    onBlur={noop}
                    disabled={fieldsDisabled}
                  />
                </DumbField>
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              {UCC_SEARCH_ALLOW_SEARCH_TYPE ? (
                <div className="flex-row">
                  <div className="no-field-padding col-sm-8 col-md-6 col-lg-4">
                    <DumbField label="File Number" className="ucc-num" required>
                      <TextInput
                        value={value.search.SEARCH_UCC_NUM}
                        onChange={(v) => this.setByKey('SEARCH_UCC_NUM', v)}
                        onBlur={noop}
                        disabled={fieldsDisabled}
                        width="100%"
                      />
                    </DumbField>
                  </div>
                </div>
              ) : null}
            </React.Fragment>
          )}
          {UCC_SEARCH_ALLOW_START_DATE ? (
            <div className="flex-row">
              <div className="no-field-padding col-sm-8 col-md-6 col-lg-4">
                <DumbField label="Start Date" description="Leave empty for all results">
                  <DateInput
                    value={value.search.BEGIN_DATE}
                    onChange={(v) => this.setByKey('BEGIN_DATE', v)}
                    onBlur={noop}
                    disabled={fieldsDisabled}
                  />
                </DumbField>
              </div>
            </div>
          ) : null}
          <div className="flex-row checkbox-padding top-box">
            <Checkbox
              fieldId={`${fieldId}-unlapsed`}
              label="Include lapsed filings on search response."
              value={value.search.SEARCH_LAPSED}
              onChange={(v) => this.setByKey('SEARCH_LAPSED', v)}
              onBlur={noop}
              disabled={fieldsDisabled}
            />
          </div>
          {uccMode.toString() === '4' && (
            <React.Fragment>
              <label className="sub-label">Select at least one of the following:</label>
              <div className="flex-row checkbox-padding">
                <Checkbox
                  fieldId={`${fieldId}-ucc`}
                  label="Include UCC Financing statements (other than farm products)"
                  value={value.search.SEARCH_UCC}
                  onChange={(v) => this.setByKey('SEARCH_UCC', v)}
                  onBlur={noop}
                  disabled={fieldsDisabled}
                />
              </div>
              <div className="flex-row checkbox-padding">
                <Checkbox
                  fieldId={`${fieldId}-tax`}
                  label="Include Government Liens (IRS, indigent, employment, state tax, etc.)"
                  value={value.search.SEARCH_GOV}
                  onChange={(v) => this.setByKey('SEARCH_GOV', v)}
                  onBlur={noop}
                  disabled={fieldsDisabled}
                />
              </div>
              <div className="flex-row checkbox-padding">
                <Checkbox
                  fieldId={`${fieldId}-efs`}
                  label="Include Effective financing statements (EFS) pertaining to farm products"
                  value={value.search.SEARCH_EFS}
                  onChange={(v) => this.setByKey('SEARCH_EFS', v)}
                  onBlur={noop}
                  disabled={fieldsDisabled}
                />
              </div>
              <div className="flex-row checkbox-padding">
                <Checkbox
                  fieldId={`${fieldId}-crop-lien`}
                  label="Include liens in crops, for seed or farm labor"
                  value={value.search.SEARCH_RA_LIEN}
                  onChange={(v) => this.setByKey('SEARCH_RA_LIEN', v)}
                  onBlur={noop}
                  disabled={fieldsDisabled}
                />
              </div>
              <div className="flex-row checkbox-padding">
                <Checkbox
                  fieldId={`${fieldId}-ag-lien`}
                  label="Include liens on agricultural products, after sale/delivery to purchasers"
                  value={value.search.SEARCH_AG_LIEN}
                  onChange={(v) => this.setByKey('SEARCH_AG_LIEN', v)}
                  onBlur={noop}
                  disabled={fieldsDisabled}
                />
              </div>
            </React.Fragment>
          )}
          <div className="flex-row button-row">
            {this.state.searching && (
              <div style={{ marginRight: '8px', marginTop: '13px' }}>
                <Spinner size="small" themeColor="dark-neutral" />
              </div>
            )}
            {!fieldsDisabled && (
              <button
                className="btn btn-primary btn-raised search-button"
                onClick={this.search}
                disabled={!this.getCanSearch()}
              >
                <SearchIcon /> &nbsp; {`${this.state.searching ? 'Searching' : 'Search'}`} &nbsp;
              </button>
            )}
          </div>
          {!this.state.searching && this.state.searchError && (
            <SearchError title="Document Search Error" message={this.state.searchError} />
          )}
          {this.state.modalOpen && (
            <ResultsModal
              template={this.state.template}
              rows={this.state.rows}
              onRequestClose={() => {
                this.setState({ modalOpen: false })
              }}
              onConfirm={this.onConfirm}
              ref={(r) => (this.resultsModal = r)}
              headless={false}
              setByKey={this.setByKey}
              search={this.buildSearch()}
              searchCount={this.state.searchCount}
            />
          )}

          {this.props.value.cache &&
            this.props.value.cache.topRows &&
            this.props.value.cache.searchCount > 0 &&
            this.state.template && (
              <div>
                <div className="ucc-result">
                  <table className="styled-table cache-table">
                    <thead>
                      <tr>
                        {this.state.template.map(({ label }, i) => (
                          <th key={i}>{label}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.value.cache.topRows.map((row, i) => (
                        <tr key={i}>
                          {this.state.template.map(({ id }, i) => (
                            <td key={i}>{row[id]}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="uccInfoRequestSearchInfo">
                  {1}-
                  {pageSize < this.props.value.cache.searchCount
                    ? pageSize
                    : this.props.value.cache.searchCount}{' '}
                  of {this.props.value.cache.searchCount}
                </div>
              </div>
            )}

          {this.props.value.cache &&
            this.props.value.cache.searchCount == 0 &&
            this.state.template && (
              <div>
                <table className="styled-table cache-table">
                  <thead>
                    <tr>
                      {this.state.template.map(({ label }, i) => (
                        <th key={i}>{label}</th>
                      ))}
                    </tr>
                  </thead>
                </table>
                <EmptySearchPlaceholder searchTerm={''} />
                <div className="uccInfoRequestSearchInfo">
                  0 - 0 of {this.props.value.cache.searchCount}
                </div>
              </div>
            )}
        </div>
      </React.Fragment>
    )
  }
}

export default connect(
  (state) => ({
    fields: state.wizard.wizard.fields,
  }),
  {
    setErrorToast,
  }
)(UCCSearch)

class ResultsModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      search: props.search,
      error: null,
      FilingListSelectMode: UCC11FilingList.ExcludeSelected,
      selected: {},
      loading: true,
      currentPage: 0,
      searchResultCount: props.searchCount,
      searchResultPageCount: (props.searchCount - (props.searchCount % pageSize)) / pageSize,
      rowData: null,
    }

    if (!this.state.rowData) {
      this.GetPage()
    }
  }

  GetPage = () => {
    SEARCH_UCC_INFO_REQ(
      { ...this.state.search, PageNumber: this.state.currentPage },
      (response) => {
        this.setState({ rowData: response, loading: false })
      },
      (err) => {
        console.error(err)
        this.setState({ loading: false, rowData: null, error: err.Message || 'An error occurred.' })
      }
    )
  }

  submitValid = () => {
    return true
  }

  uncheckAll = () => {
    this.setState({
      FilingListSelectMode: UCC11FilingList.IncludeSelected,
      selected: {},
      error: null,
    })
  }

  checkAll = () => {
    this.setState({
      FilingListSelectMode: UCC11FilingList.ExcludeSelected,
      selected: {},
      error: null,
    })
  }

  calculateEndOfPage = () => {
    let endOfPage = (this.state.currentPage + 1) * pageSize
    return endOfPage < this.state.searchResultCount ? endOfPage : this.state.searchResultCount
  }

  calcualateBoxChecked = (row) => {
    switch (this.state.FilingListSelectMode) {
      case UCC11FilingList.ExcludeSelected:
        return !(row.FileNumber in this.state.selected)
      case UCC11FilingList.IncludeSelected:
        return row.FileNumber in this.state.selected
      default:
        return false
    }
  }

  onConfirm = (callback) => {
    if (!this.submitValid()) {
      this.setState({ error: 'You must select at least one record to continue.' })
      return
    } else {
      this.setState({ error: null })
    }
    this.props.onConfirm({
      template: this.props.template,
      selectedRows: Object.keys(this.state.selected),
      selectionMode: this.state.FilingListSelectMode,
    })
    if (callback) {
      callback()
    }
  }

  render() {
    const { onRequestClose, template, headless } = this.props
    return (
      <Portal isOpened={headless ? false : true}>
        <Modal
          modalSize="extra-large"
          title="-- UCC Documents --"
          closeModal={onRequestClose}
          closeButton
        >
          {({ closeModal }) => (
            <React.Fragment>
              {!template ? (
                <div>
                  <Spinner />
                </div>
              ) : (
                <div className="scrollable ucc-scrollable">
                  <div className="ucc-search-confirm">
                    <div className="ucc-search-modal">
                      <div className="button-wrapper">
                        <button className="btn btn-secondary" onClick={this.uncheckAll}>
                          Uncheck all
                        </button>
                        <button className="btn btn-secondary" onClick={this.checkAll}>
                          Check all
                        </button>
                      </div>
                      {!this.state.rowData ? (
                        <div>
                          {' '}
                          <Spinner />{' '}
                        </div>
                      ) : (
                        <table className="form-table">
                          <thead>
                            <tr>
                              <th />
                              {template.map(({ label }, i) => (
                                <th key={i}>{label}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.rowData.map((row, i) => {
                              const checked = this.calcualateBoxChecked(row)
                              return (
                                <tr
                                  className={`clickable wizard ${checked ? 'checked' : 'unchecked'
                                    }`}
                                  onClick={() => {
                                    const selected = { ...this.state.selected }
                                    if (this.state.selected[row.FileNumber]) {
                                      delete selected[row.FileNumber]
                                    } else {
                                      selected[row.FileNumber] = true
                                    }
                                    this.setState({ selected: selected })
                                  }}
                                  key={i}
                                >
                                  <td>
                                    <Checkbox value={checked} />
                                  </td>

                                  {template.map(({ id }, i) => (
                                    <td key={i}>{row[id]}</td>
                                  ))}
                                </tr>
                              )
                            })}
                          </tbody>
                        </table>
                      )}
                    </div>
                  </div>
                  <div className="ucc-toolbar">
                    <div className="button-wrapper">
                      {this.state.loading && (
                        <div style={{ marginTop: '12px', marginRight: '8px' }}>
                          <Spinner size="small" themeColor="dark-neutral" />
                        </div>
                      )}
                      <span style={{ paddingTop: '8px' }}>
                        {this.state.currentPage * pageSize + 1}-{this.calculateEndOfPage()} of{' '}
                        {this.state.searchResultCount}
                      </span>

                      <button
                        aria-invalid={this.state.error ? true : ''}
                        className="btn btn-secondary"
                        id="ucc-doc-submit"
                        disabled={this.state.loading}
                        onClick={() => {
                          if (this.state.currentPage > 0) {
                            this.setState(
                              {
                                loading: true,
                                currentPage: this.state.currentPage - 1,
                              },
                              () => {
                                this.GetPage()
                              }
                            )
                          }
                        }}
                      >
                        Previous
                      </button>

                      <button
                        aria-invalid={this.state.error ? true : ''}
                        className="btn btn-secondary"
                        id="ucc-doc-submit"
                        disabled={this.state.loading}
                        onClick={() => {
                          if (this.state.currentPage < this.state.searchResultPageCount) {
                            this.setState(
                              {
                                loading: true,
                                currentPage: this.state.currentPage + 1,
                              },
                              () => {
                                this.GetPage()
                              }
                            )
                          }
                        }}
                      >
                        Next
                      </button>

                      <button
                        aria-invalid={this.state.error ? true : ''}
                        className="btn btn-secondary"
                        id="ucc-doc-submit"
                        onClick={() => {
                          this.onConfirm(closeModal, this.setError)
                        }}
                      >
                        Confirm
                      </button>

                      <HelpTooltip ariaDescribedBy="ucc-doc-submit" message={this.state.error} />
                    </div>
                  </div>
                </div>
              )}
            </React.Fragment>
          )}
        </Modal>
      </Portal>
    )
  }
}

export const UCCSearchDisplay = ({
  uccMode,
  value,
  disabled,
  showSearchCriteriaType,
  defaultSearchCriteriaType,
  showSecuredPartySearchType,
}) => {
  const individualOrg = {
    label: 'Individual or Organization:',
    value: value.IS_ORG ? 'Organization' : 'Individual',
  }
  const searchCriteriaType = value.SEARCH_CRITERIA_TYPE || defaultSearchCriteriaType
  const cells = [
    showSearchCriteriaType
      ? {
        label: 'Search Criteria Type:',
        value: searchCriteriaType === '1' ? 'RA9 Search' : 'Wildcard Search',
      }
      : null,
    {
      label: UCC_SEARCH_ALLOW_SEARCH_TYPE ? 'Request Type:' : 'Search Type:',
      value:
        value.SEARCH_REQUEST_TYPE === 'LIST_ONLY'
          ? 'Search request only'
          : 'Both search and copy request',
    },
    UCC_SEARCH_ALLOW_SEARCH_TYPE
      ? {
        label: 'Search Type:',
        value:
          value.SEARCH_TYPE === 'DEBTOR'
            ? 'Debtor Search'
            : value.SEARCH_TYPE === 'SECURED_PARTY'
              ? 'Secured Party Search'
              : value.SEARCH_TYPE === 'UCC_NUM'
                ? 'File Number Search'
                : value.SEARCH_TYPE,
      }
      : null,
    ...((
      UCC_SEARCH_ALLOW_SEARCH_TYPE
        ? value.SEARCH_TYPE === 'DEBTOR' || value.SEARCH_TYPE === 'SECURED_PARTY'
        : true
    )
      ? value.IS_ORG === true || value.IS_ORG === 'true'
        ? [individualOrg, { label: 'Organization name:', value: value.SEARCH_ORG_NAME }]
        : [
          individualOrg,
          {
            label: 'Individual Name:',
            value: (
              <FullNameDisplay
                value={{
                  FIRST_NAME: value.SEARCH_FIRST_NAME,
                  MIDDLE_NAME: value.SEARCH_MIDDLE_NAME,
                  LAST_NAME: value.SEARCH_LAST_NAME,
                  SUFFIX: value.SEARCH_SUFFIX,
                }}
              />
            ),
          },
        ]
      : [
        {
          label: 'File Number:',
          value: value.SEARCH_UCC_NUM,
        },
      ]),
    UCC_SEARCH_ALLOW_SEARCH_TYPE && value.SEARCH_TYPE === 'UCC_NUM'
      ? null
      : {
        label: 'City:',
        value: value.SEARCH_CITY,
      },
    UCC_SEARCH_ALLOW_SEARCH_TYPE && value.SEARCH_TYPE === 'UCC_NUM'
      ? null
      : {
        label: 'State:',
        value: value.SEARCH_STATE,
      },
    UCC_SEARCH_ALLOW_START_DATE
      ? {
        label: 'Start Date:',
        value: value.BEGIN_DATE
          ? format(new Date(value.BEGIN_DATE), 'MM/dd/yyyy')
          : value.BEGIN_DATE,
      }
      : null,
    {
      label: 'Include lapsed filings on search response:',
      value: value.SEARCH_LAPSED ? 'Yes' : 'No',
    },
    {
      label: 'Total Filings Found',
      value: value.Count,
    },
    ...(uccMode.toString() === '4'
      ? [
        {
          label: 'Include UCC Financing statements:',
          value: value.SEARCH_UCC ? 'Yes' : 'No',
        },
        {
          label: 'Include Government Liens:',
          value: value.SEARCH_GOV ? 'Yes' : 'No',
        },
        {
          label: 'Include Effective Financing Statements:',
          value: value.SEARCH_EFS ? 'Yes' : 'No',
        },
        {
          label: 'Include liens in crops:',
          value: value.SEARCH_RA_LIEN ? 'Yes' : 'No',
        },
        {
          label: 'Include liens on agricultural products:',
          value: value.SEARCH_AG_LIEN ? 'Yes' : 'No',
        },
      ]
      : []),
  ].filter((x) => x !== null)

  return (
    <div className="ucc-search-display">
      {cells.map((cell, i) => (
        <div className="flex-row ucc-summary-row" key={i}>
          <label className="ucc-label">{cell.label}</label>
          <span className="ucc-value">{cell.value}</span>
        </div>
      ))}
    </div>
  )
}

export class UCCSearchSummary extends React.Component {
  constructor(props = {}) {
    super(props)
    this.state = {
      searching: false,
      rows: null,
      currentPage: 0,
      currentRows: props.value.cache.topRows,
    }
  }

  render = () => {
    const { field } = this.props

    return field.value.cache && field.value.cache.topRows ? (
      <React.Fragment>
        <div style={{ width: '100%', overflowX: 'auto', padding: 0 }}>
          <table className="styled-table">
            <thead>
              <tr>
                {field.value.cache.template.map(({ label }, i) => (
                  <th key={i}>{label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {this.state.currentRows.map((row, i) => (
                <tr key={i}>
                  {field.value.cache.template.map(({ id }, i) => (
                    <td key={i}>{row[id]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {field.value.cache.topRows.length > 0 ? (
          <div className="button-wrapper">
            <span style={{ paddingTop: '7px' }}>
              {1 + pageSize * this.state.currentPage} -
              {pageSize < field.value.cache.searchCount
                ? field.value.cache.searchCount < pageSize * (this.state.currentPage + 1)
                  ? field.value.cache.searchCount
                  : pageSize * (this.state.currentPage + 1)
                : field.value.cache.searchCount}{' '}
              of {field.value.cache.searchCount}
            </span>
            <button
              className="btn btn-secondary"
              id="ucc-doc-submit"
              onClick={() => {
                if (this.state.currentPage > 0 && this.state.searching == false) {
                  this.setState(
                    { currentPage: this.state.currentPage - 1, searching: true },
                    this.getPage
                  )
                }
              }}
            >
              Previous
            </button>
            <button
              className="btn btn-secondary"
              id="ucc-doc-submit"
              onClick={() => {
                if (
                  this.state.currentPage <
                  (field.value.cache.searchCount - (field.value.cache.searchCount % pageSize)) /
                  pageSize &&
                  this.state.searching == false
                ) {
                  this.setState(
                    { currentPage: this.state.currentPage + 1, searching: true },
                    this.getPage
                  )
                }
              }}
            >
              Next
            </button>
          </div>
        ) : null}
      </React.Fragment>
    ) : null
  }

  getPage = () => {
    SEARCH_UCC_INFO_REQ(
      {
        ...this.buildSearch(this.props.value.search),
        PageNumber: this.state.currentPage,
        SelectedRows: this.props.value.cache.selectedRows,
        SelectionMode: this.props.value.cache.selectionMode,
      },
      (records) => {
        this.setState({ currentRows: records, searching: false })
      }
    )
  }

  buildSearch = (search) => {
    let isOrg = search.IS_ORG === 'true' || search.IS_ORG === true
    return {
      SEC_PARTY_SEARCH_YN: false,
      SEARCH_IS_ORG: isOrg,
      SEARCH_LAST_NAME: isOrg ? '' : search.SEARCH_LAST_NAME,
      SEARCH_FIRST_NAME: isOrg ? '' : search.SEARCH_FIRST_NAME,
      SEARCH_MIDDLE_NAME: isOrg ? '' : search.SEARCH_MIDDLE_NAME,
      SEARCH_SUFFIX: isOrg ? '' : search.SEARCH_SUFFIX,
      SEARCH_ORG_NAME: isOrg ? search.SEARCH_ORG_NAME : '',
      SEARCH_CITY: search.SEARCH_CITY,
      SEARCH_STATE: search.SEARCH_STATE,
      SEARCH_LAPSED: search.SEARCH_LAPSED,
      SEARCH_TYPE: search.SEARCH_TYPE,
      SEARCH_CRITERIA_TYPE: search.SEARCH_CRITERIA_TYPE,
      SEARCH_REQUEST_TYPE: search.SEARCH_REQUEST_TYPE,
      SEARCH_UCC: search.SEARCH_UCC,
      SEARCH_GOV: search.SEARCH_GOV,
      SEARCH_EFS: search.SEARCH_EFS,
      SEARCH_RA_LIEN: search.SEARCH_RA_LIEN,
      SEARCH_AG_LIEN: search.SEARCH_AG_LIEN,
      SEARCH_UCC_NUM: search.SEARCH_UCC_NUM,
      BEGIN_DATE: search.BEGIN_DATE,
      PageSize: pageSize,
      ADDITIONAL_PARAMS: search.ADDITIONAL_PARAMS,
    }
  }
}
